export const DESKTOP_BREAKPOINT = 1024;
export const TAB_BREAKPOINT = 768;

export const DESKTOP_TAB_CATEGORY_COUNT = 6;
export const TABLET_TAB_CATEGORY_COUNT = 5;
export const MOBILE_TAB_CATEGORY_COUNT = 0;
